import { render, staticRenderFns } from "./SdsSearchForm.vue?vue&type=template&id=74fb01ea"
import script from "./SdsSearchForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsSearchForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports